export default __webpack_public_path__ + "img/cVDrZgwB.ce5ea35b.svg";